export default __webpack_public_path__ + "static/media/soorya.c6b6af96.jpg";